export const ENTITY_STATUS_FILTERS = ['all', 'active', 'inactive', 'archived'] as const;

export type EntityStatusFilter = typeof ENTITY_STATUS_FILTERS[number];

export const ENTITY_STATUS_FILTER_LABELS: Record<EntityStatusFilter, string> = {
  all: 'Tous',
  active: 'Actifs',
  inactive: 'Inactifs',
  archived: 'Archivés',
};

export type EntityListFilters = {
  isActive?: boolean;
  archived?: boolean;
};

export function toEntityListFilters(status: EntityStatusFilter): EntityListFilters {
  switch (status) {
    case 'active':
      return { isActive: true };
    case 'inactive':
      return { isActive: false };
    case 'archived':
      return { archived: true };
    default:
      return {};
  }
}

export const ARCHIVABLE_STATUS_FILTERS = ['active', 'archived'] as const;

export type ArchivableStatusFilter = typeof ARCHIVABLE_STATUS_FILTERS[number];

export const ARCHIVABLE_STATUS_FILTER_LABELS: Record<ArchivableStatusFilter, string> = {
  active: 'Actives',
  archived: 'Archivées',
};

export function toArchivableListFilters(status: ArchivableStatusFilter): { archived?: boolean } {
  return status === 'archived' ? { archived: true } : {};
}
